import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Provider } from '../../domain/entities/Provider'
import { GetProvidersUseCase } from '../../usecases/GetProvidersUseCase'
import { AxiosProviderRepository } from '../../infrastructure/AxiosProviderRepository'
import { RootState } from '../../../store/store'

const useCase = new GetProvidersUseCase(new AxiosProviderRepository())

export function useProviders(shouldFetch: boolean = true): {
  providers: Provider[]
  loading: boolean
  error: string | null
} {
  const [providers, setProviders] = useState<Provider[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const countryCode = useSelector((state: RootState) => state.user.user?.company?.country?.code)

  useEffect(() => {
    if (!shouldFetch) {
      setProviders([])
      setLoading(false)
      return
    }

    setLoading(true)
    const code = countryCode

    useCase.execute(code)
      .then((result) => {
        setProviders(result)
        setLoading(false)
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : String(err))
        setLoading(false)
      })
  }, [shouldFetch, countryCode])

  return { providers, loading, error }
}
